import type { SVGProps } from 'react'
const SvgSyArchive = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path
			fillOpacity={0.24}
			d="M3 10c0-2.828 0-4.243.879-5.121S6.172 4 9 4h6c2.828 0 4.243 0 5.121.879S21 7.172 21 10s0 4.243-.879 5.121S17.828 16 15 16H9c-2.828 0-4.243 0-5.121-.879S3 12.828 3 10"
		/>
		<path
			fillRule="evenodd"
			d="M5.567 12h-.711c-.804 0-1.205 0-1.479.218q-.088.07-.16.16C3 12.65 3 13.051 3 13.855V15c0 2.828 0 4.243.879 5.121S6.172 21 9 21h6c2.828 0 4.243 0 5.121-.879S21 17.828 21 15v-1.144c0-.804 0-1.205-.218-1.479q-.07-.088-.16-.16C20.35 12 19.949 12 19.145 12h-.71c-.7 0-1.049 0-1.343.093a2 2 0 0 0-1.178.998c-.14.275-.198.62-.313 1.309-.029.172-.043.258-.078.327a.5.5 0 0 1-.295.25c-.073.023-.16.023-.335.023H9.108c-.174 0-.262 0-.335-.023a.5.5 0 0 1-.295-.25c-.035-.069-.05-.155-.078-.327-.115-.689-.172-1.034-.313-1.309a2 2 0 0 0-1.178-.998C6.615 12 6.265 12 5.567 12M9.5 17a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1z"
			clipRule="evenodd"
		/>
	</svg>
)
export default SvgSyArchive
